
<div *ngIf="rule !== undefined && reference !== undefined">
<p-table [value]="ruleEntries" dataKey="shortValue" class="table table-condensed" tableStyle="">
  <ng-template pTemplate="header">
    <tr>
      <th class="th-upper"  width="2%">
        &nbsp;
      </th>
      <th class="th-upper" width="38%" style="border-right: 1px solid #ccc;  padding-left: 12px">
        <div class="pull-left">{{ name }}</div>
      </th>
      <th class="th-upper" width="60%">
        <div style="margin-left: 6px;">Map to this in message </div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rule>
    <tr [pEditableRow]="rule" >
      <td style="border: 1px solid #ccc; border-left: none; border-right: none;">
        <p-checkbox class="form-check-input" name="groupname"
                    [(ngModel)] = "rule.defaultFlag" [binary]="true"
                    (onChange)="updateDefault($event.checked, rule)"
                    tooltip="Click to select as default value"
        ></p-checkbox>
      </td>
      <td style="border: 1px solid #ccc; border-left: none;">
        {{rule.displayName}}
      </td>
       <td [pEditableColumnField]="rule"
           [pEditableColumn]="rule"
           style="border: 1px solid #ccc; padding-left: 12px; width: 100%; display: inline-flex">
         <div *ngIf="mediaType === 'voice'" style="display: inline-flex">
         <input
             class="form-control"
             style="min-width: 185px; border: none; box-shadow: none; font-size: 13px; padding: 0"
             [style]="{'width':'20%'}"
             placeholder="Enter text here"
             type="number"
             min="0"
             [(ngModel)]="rule.expandedValue"
             (keyup)="updateSoundId(rule, $event)"
             (keydown)="onKeyDown($event)"
         />

         <div
             style="border: none"
             *ngIf="rule.sound.audioService.getPlayerStatus() | async as playerStatus"
         >
         </div>
         </div>
         <div *ngIf="mediaType !== 'voice'" style="width: 100%">
           <textarea
               class="form-control"
               style="min-width: 185px; border: none; box-shadow: none; font-size: 13px; padding: 0; resize: vertical;"
               [style]="{'width': '100%'}"
               placeholder="Enter text here"
               [(ngModel)]="rule.expandedValue"
               (keyup)="updateSoundId(rule, $event)"
           ></textarea>
         </div>
      </td>
    </tr>
  </ng-template>
</p-table>
</div>